import { combineReducers } from "redux";

import permissionFetch from "redux/reducer/services/PermissionFetch/permissionFetchReducer";
import draftBulletinFetch from "redux/reducer/services/Bulletin/DraftBulletinFetch/draftBulletinFetchReducer";
import publishedBulletinFetch from "redux/reducer/services/Bulletin/PublishedBulletinFetch/publishedBulletinFetchReducer";
import retiredBulletinFetch from "redux/reducer/services/Bulletin/RetiredBulletinFetch/retiredBulletinFetchReducer";
import scheduledPublishBulletinFetch from "redux/reducer/services/Bulletin/ScheduledPublishBulletinFetch/scheduledPublishBulletinFetchReducer";
import pendingBulletinFetch from "redux/reducer/services/Bulletin/PendingBulletinFetch/pendingBulletinFetchReducer";
import requestBulletinApprovalModal from "redux/reducer/component/Modal/RequestBulletinApprovalModal/requestBulletinApprovalModalReducer";
import publishBulletinModal from "redux/reducer/component/Modal/PublishBulletinModal/publishBulletinModalReducer";
import auditBulletinModal from "redux/reducer/component/Modal/AuditBulletinModal/auditBulletinModalReducer";
import mailinglistBulletinModal from "redux/reducer/component/Modal/MailinglistBulletinModal/mailinglistBulletinModalReducer";
import emailBulletinModal from "redux/reducer/component/Modal/EmailBulletinModal/emailBulletinModalReducer";
import retireBulletinModal from "redux/reducer/component/Modal/RetireBulletinModal/retireBulletinModalReducer";
import deleteBulletinModal from "redux/reducer/component/Modal/DeleteBulletinModal/deleteBulletinModalReducer";
import bulletinDetailModal from "redux/reducer/component/Modal/BulletinDetailModal/bulletinDetailModalReducer";
import bulletinViewModal from "redux/reducer/component/Modal/BulletinViewModal/bulletinViewModalReducer";
import thumbBulletinModal from "redux/reducer/component/Modal/ThumbBulletinModal/thumbBulletinModalReducer";
import argumentFetch from "redux/reducer/services/ArgumentFetch/argumentFetchReducer";

const reducers = combineReducers({
  permissionFetch,
  draftBulletinFetch,
  publishedBulletinFetch,
  retiredBulletinFetch,
  scheduledPublishBulletinFetch,
  pendingBulletinFetch,
  requestBulletinApprovalModal,
  publishBulletinModal,
  auditBulletinModal,
  mailinglistBulletinModal,
  emailBulletinModal,
  retireBulletinModal,
  bulletinDetailModal,
  deleteBulletinModal,
  bulletinViewModal,
  thumbBulletinModal,
  argumentFetch
});

export default reducers;
